export default __webpack_public_path__ + "static/media/gray_dots.539d9601.jpg";